<template>
  <div v-loading="loading" class="filter-bar">
    <app-select v-for="item of filterItems.slice(0,separatorIndex)" :key="item.name" :ref="`appSelect_${item.name}`" class="select-row" :label="$t('filterBar.' + item.name)" :options="item.name === 'district' ? districtOptions : item.options" :default="item.default" :multiple="item.multiple" :allow-cancel="item.allowCancel" :any="item.any" @change="onSelectChange" :name="item.name" />
    <!-- 价格区间 -->
    <div class="slider-wrap">
      <label class="app-select--label">{{ $t('filterBar.priceRange') }}: </label>
      <el-slider class="slider" v-model="result.priceRange" range :min="0" :max="1000000" :marks="marks" :format-tooltip="formatTooltip" @change="onPriceChange" />
    </div>
    <div class="section-more" v-if="filterItems.slice(separatorIndex,filterItems.length)">
      <div class="hr" v-if="!isShowMore" @click="isShowMore = true">
        <span>{{ $t('filterBar.more') }}</span>
        <font-icon id="down"></font-icon>
      </div>
      <div class="hr" v-if="isShowMore" @click="isShowMore = false">
        <span>{{ $t('filterBar.less') }}</span>
        <font-icon id="up"></font-icon>
      </div>
    </div>
    <app-select v-if="isShowMore" v-for="item of filterItems.slice(separatorIndex,filterItems.length)" :key="item.name" :ref="`appSelect_${item.name}`" class="select-row" :label="$t('filterBar.' + item.name)" :options="item.name === 'district' ? districtOptions : item.options" :default="item.default" :multiple="item.multiple" :allow-cancel="item.allowCancel" :any="item.any" @change="onSelectChange" :name="item.name" />
  </div>
</template>
<script>
import AppSelect from '../AppSelect'
import SELLFILTERITEMS from '@/common/filter_sell'
import filterBarMixin from '@/common/filter.js'

export default {
  data() {
    return {
      marks: {
        0: '$0',
        1000000: this.$t('noLimitPrice'),
      },
      items: ['city', 'district', 'school', 'familyType', 'houseType', 'propertyType', 'elevator', '|'], //用于项目调整排序
      result: {
        // result 保存每个筛选结果的 ID List
        priceRange: [0, 1000000]
      }
    }
  },
  mixins: [filterBarMixin],
  components: {
    AppSelect,
  },
  mounted() {
    this.items.splice(0, this.separatorIndex).forEach(item => {
      let o = SELLFILTERITEMS[item]
      this.filterItems.push(o)
    })
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios({
          url: '/api/v1/client/estate/sell/getSetting',
          method: 'get',
        })
        .then(res => {
          this.renderFilterItems(res, 'SELL_FEATURE_')
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
}

</script>
